import { BlazeError } from '@blaze-cms/core-errors';

function componentMapHandler() {
  const components = new Map();
  function get(key) {
    return components.get(key);
  }

  function getAll() {
    return Array.from(components.entries());
  }

  function add({ key, component }) {
    validate(key, component);
    components.set(key, component);
  }

  function validate(key, component) {
    if (!key || !component) throw new BlazeError('Component requires key and component');
    if (components.has(key) && key !== 'array') throw new BlazeError(`Component already exists`);
  }

  return {
    id: Math.random(),
    add,
    get,
    getAll
  };
}

const componentMap = componentMapHandler();

export default componentMap;
